import 'bootstrap'
import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'
import './select_checkbox'
import './required_checkbox'
import './share_social'
import { commercialTable } from './commercial_table'
import { initMenuSticky } from './menu_sticky'
import { initMenuControl } from './menu_control'
import { init as initOffersFilter } from './offers/filter'
import { initFilterCounters } from './offers/common-catalog.js'
import { fillAdvertName, initForm } from './form'
import { moveHelpTextToDragAndDrop } from './form-drag-and-drop'
import { catchaRefresh } from './captcha.js'
import { initCarousels } from './carousel'

document.addEventListener('DOMContentLoaded', () => {
    // Because message 'Enter a valid email address.' is hidden.
    for (const email of document.querySelectorAll('.base-form input[type=email].has-error')) {
        if (email.value) {
            email.classList.add('email-error')
        }

        email.addEventListener('input', () => {
            email.classList.remove('email-error')
        })
    }

    for (const svg of document.querySelectorAll('.cooperation aside img')) {
        svg.insertAdjacentHTML('afterend', `<div class="info-tooltip" >${svg.alt}</div>`)
    }

    // Open according collapse
    for (const collapse of document.querySelectorAll('.collapse-box')) {
        if (collapse.querySelector('*[id*="open"') && !window.location.hash) {
            collapse.querySelector('header[id^=trigger-open]').classList.remove('collapsed')
            collapse.querySelector('header[id^=trigger-open]').setAttribute('aria-expanded', true)
            collapse.querySelector('aside[id^=open]').classList.add('collapse', 'show')
        }
    }

    for (const item of document.querySelectorAll('.prevent-default')) {
        item.href = ''
    }

    // Add subject for link with mailto
    for (const link of document.querySelectorAll('a[href^="mailto"]')) {
        if (link.dataset.subject) {
            link.href = `${link.href}?subject=${link.dataset.subject}`
        }
    }

    // Open first nav tab, nav pills
    for (const tabs of document.querySelectorAll('ul[role="tablist"][class*="nav-"].nav')) {
        tabs.querySelector('.nav-item button').click()
    }

    // If url has hash try to open collapse
    if (window.location.hash) {
        if (document.getElementById(`${window.location.hash.replace('#', '')}`)) {
            document.getElementById(`${window.location.hash.replace('#', '')}`).click()
        }
    }

    // Open navigation items in a new tab
    for (const link of document.querySelectorAll('.page-navigation a[href]')) {
        if (!link.href.includes(window.location.host)) {
            link.setAttribute('target', '_blank')
        }
    }

    commercialTable()
    initMenuSticky()
    initMenuControl()
    initOffersFilter()
    fillAdvertName()
    moveHelpTextToDragAndDrop()
    initForm()
    initFilterCounters()
    catchaRefresh()
    initCarousels()

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => { setTimeout(setCMSBarWidth, 1000) }, true)
    }

    const catalogDetail = document.querySelector('.common-catalog.detail')
    if (catalogDetail) {
        const catalogItem = catalogDetail.querySelector('.catalog-item')
        const positionTitle = catalogItem.classList[1] || null
        if (positionTitle) {
            const catalogTitle = document.querySelector(`.common-catalog.inzeraty .${positionTitle}`)
            if (catalogTitle) {
                catalogTitle.classList.add('catalog-item-hover')
                catalogTitle.removeAttribute('href')
            }
        }
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))

    // Background colors are in css but the user wants to be able to set the background
    // and text color in the administration
    const perexList = document.querySelectorAll('.common-catalog.detail .perex, .common-catalog.list .catalog-item .perex')
    perexList.forEach(perex => {
        perex.querySelectorAll('li').forEach(item => {
            const bgSpan = item.querySelector('span')
            if (bgSpan && bgSpan.style.backgroundColor) {
                item.style.backgroundColor = bgSpan.style.backgroundColor
            }
        })
    })
})

addEventListener('resize', commercialTable)

import './cms_toolbar'
